const history = {
  title: 'Мои проекты',
  upgradeBtn: 'Обновить',
  subTitle:
    'Не забыть скачать свой файл, так как он будет удален через 72 часа.',
  MAgo: '{{num}} минут назад',
  HAgo: '{{num}} часов назад',
  DAgo: '{{num}} часов назад',
  justNow: 'Только что',
  originalFile: 'Оригинальный файл',
  selectAllBtn: 'Выбрать все',
  emptyTips: 'Пока никаких проектов. <1>Перейти к редактированию</1>',
  deleteTips: 'Вы уверены, что хотите это удалить?',
};

export default history;
